module.exports = __webpack_public_path__ + "img/placeholder_UT.5fc9126c.jpg";